import { fromUrlVendor } from "../../../helper/vendorMask";

export const hotelQueryParams = (location) => {
  const query = new URLSearchParams(location.search);
  const city = query.get("cid");
  const hid = query.get("hid");
  const ratings = query.get("ratings")?.split("_");
  const nationality = query.get("nationality");
  const searchWith = query.get("searchWith");
  const vendor = fromUrlVendor(query.get("vendor"));
  const keyword = query.get("keyword");
  const countryOfResidence = query.get("countryOfResidence");
  const amount = query.get('amount')
  const cityname = query.get("cityname")
  const residence = query.get("residence");
  const isHotel = query.get("isH");
  const hrCityId = query.get("hrCityId"); // resolved HotelRack city id carried from search
  let searchData = null;
  try {
    const searchDataParam = query.get("searchData");
    if (searchDataParam) {
      const decoded = decodeURIComponent(atob(searchDataParam));
      searchData = JSON.parse(decoded);
    }
  } catch (error) {
    searchData = null;
  }
  const commonId = query.get("commonId")
  const roomInfo = query
    .get("ris")
    ?.split("_")
    ?.map((d) => {
      const details = d?.split("n");
      return {
        noOfAdult: details?.[0],
        noOfChild: details?.[1] ?? 0,
        childAges: details?.[2]?.split("a"),
      };
    });
  const checkinDate = query.get("checkinDate");
  const checkoutDate = query.get("checkoutDate");
  const fsc = query.get("fsc");

  return {
    city,
    hid,
    ratings,
    nationality,
    searchWith,
    countryOfResidence,
    roomInfo,
    checkinDate,
    checkoutDate,
    fsc,
    vendor,
    keyword,
    amount,
    cityname,
    commonId, searchData, residence , isHotel, hrCityId
  };
};
